/* eslint-disable */
import axios from "axios";
import '../utils/axios.interceptor';
import { format } from "date-fns";
import { urlCoreBack } from "../configs/config";

const epName = "v1/orden-envio/";
const nameItemsText = "Ordenes de Envío";
const nameItemText = "Orden de Envío";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getOrdenesEnvio = async (params) => {
	let _params = {};
	let _errorMessage = "Se produjo un error al obtener Gestiones de Atención";

	_params.id_area_solicita = localStorage.getItem("id_area_ventas");

	if (params.codigoGestionAtencion) {
		_params.gc_codigo = params.codigoGestionAtencion;
	}

	if (params.codigoOrdenEnvio) {
		_params.codigo = params.codigoOrdenEnvio;
	}

	if (params.sucursalGenera) {
		_params.id_area_genera = params.sucursalGenera;
	}

	if (params.sucursalEnvia) {
		_params.id_area_envia = params.sucursalEnvia;
	}

	if (params.sucursalEnvia) {
		_params.id_area_envia = params.sucursalEnvia;
	}

	if (params.usuario) {
		_params.id_usuario = params.usuario;
	}

	if (params.fechaCreacionDesde) {
		_params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
	}

	if (params.fechaCreacionHasta) {
		_params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
	}

	if (params.estadoActual) {
		_params.estado_actual = params.estadoActual;
	}

	if (params.fechaEstadoDesde) {
		_params.fecha_estado_desde = format(params.fechaEstadoDesde, "yyyy/MM/dd");
	}

	if (params.fechaEstadoHasta) {
		_params.fecha_estado_hasta = format(params.fechaEstadoHasta, "yyyy/MM/dd");
	}

	if ('rows' in params) {
		_params.rows = params.rows;
	}

	if ('first' in params) {
		_params.first = params.first;
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getOrdenEnvio = async (parIdOrdenEnvio) => {
	let _errorMessage = "Se produjo un error al obtener la Gestión de Atencion";

	let _params = {
		id: parIdOrdenEnvio,
		id_area_solicita: localStorage.getItem("id_area_ventas"),
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const ordenEnvioAProduccion = async (parIdOrdenEnvio, parObservaciones) => {
	let _errorMessage = `No fue posible el envío a producción de la Orden de Envío`;

	let _epName = "v1/orden-envio/enviar/";

	let _params = {
		id: parIdOrdenEnvio,
		id_area_envia: localStorage.getItem("id_area_ventas"),
		id_usuario: localStorage.getItem("id_usuario"),
		observaciones: parObservaciones,
	}

	try {
		let response = await axios({
			method: "PUT",
			url: `${urlCoreBack}${_epName}`,
			data: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				let _messageText = "Orden de Envío enviada a producción";
				response.messageText = _messageText;
				response.messageSeverity = "success";
			} else {
				// si hay error controlado

				response.messageText = _errorMessage;
				response.ok = false;
				response.messageSeverity = "warning";

				console.log(_errorMessage);
				console.log(response);
			}
			return response;
		}
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};